module.exports = __webpack_public_path__ + "img/MB_lobby.b021924a.jpg";